import request from "@/utils/request";

/**
 * 获取门店分页
 *
 */
export function storePage(data, token, businessType) {
  const cur = businessType === 'LIFE' ? "/admin-api/life/" : "/admin-api/medical/";
  return request({
    url: `${cur}store/page`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    data,
  });
}

/**
 * 获取医生/美容师列表
 */
export function doctorPage(params, token, businessType) {
  const cur = businessType === 'LIFE' ? "/admin-api/life/" : "/admin-api/medical/";
  const path = businessType === 'LIFE' ? "beautician/display/page" : "doctor/display/page";
  return request({
    url: `${cur}${path}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
       "Business-Type": businessType,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    params,
  });
}
